export default {
    computed: {
        columns() {
            return this.column_names === 'status' ? this.statuses : this.sections;
        },
    },
    methods: {
        async init() {
            try {
                await this.loadTab(); // Wait until the tab is loaded
                this.newStatusId = this.tab.default_status_id;
                this.newSectionId = this.tab.default_section_id;

                this.defaultNewStatusId = this.tab.default_status_id;
                this.defaultNewSectionId = this.tab.default_section_id;

                this.orderBy = this.tab.default_sorting.by;
                this.orderDirection = this.tab.default_sorting.direction;

                this.loading = false;
                this.loadPosts(); // Call another method if needed
            } catch (error) {
                console.error("Failed to load the tab:", error);
                // Handle any errors that occurred during loadTab
            }
        },
        onSubmitSearch() {
            const url = `/search?q=${encodeURIComponent(this.searchQuery)}&tab_id=${this.tab.id}`;
            window.location.href = url;
        },
        filterCategory(id) {
            this.selectedCategoryId = id
            this.loadPosts();
        },
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        sendHeight() {
            // Allow the DOM to update before calculating the height
            this.$nextTick(() => {
                const height = document.documentElement.scrollHeight;
                window.parent.postMessage({ height }, '*');
            });
        },
        setOrder(field) {
            if (this.orderBy === field) {
                // If the same field is selected, toggle the direction
                this.orderDirection = this.orderDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // If a new field is selected, set it and default to descending order
                this.orderBy = field;
                this.orderDirection = 'desc';
            }
            this.loadPosts();
        },
        loadPosts() {
            this.columns.forEach(column => {
                const columnId = column.id;
                this.sectionLoading[columnId] = true;
                this.currentPage[columnId] = 1;
                this.sectionHasMore[columnId] = false;
                this.fetchPostsForColumn(columnId);
            });

            // Only load posts without section when in section mode
            if (this.column_names === 'section') {
                this.sectionLoading[null] = true;
                this.currentPage[null] = 1;
                this.sectionHasMore[null] = false;
                this.fetchPostsForColumn(null);
            }

            this.sendHeight();
        },

        fetchPostsForSection(sectionId, skip = 0, addToExisting = false) {
            let postsPerPage = this.postsPerPage

            let queryParams = new URLSearchParams({
                tab: this.dataSlug,
                section: sectionId === null ? 'null' : sectionId,
                skip: skip.toString(),
                limit: postsPerPage.toString(),
                order_by: this.orderBy,
                order_direction: this.orderDirection
            });

            if (this.selectedCategoryId) {
                queryParams.append('category', this.selectedCategoryId);
            }

            this.$http.get(`/http_api/posts?${queryParams.toString()}`)
                .then(({ data }) => {
                    const postsArray = data.data || [];

                    if (sectionId === null) {
                        if (addToExisting) {
                            this.postsWithoutSection = [...this.postsWithoutSection, ...postsArray];
                        } else {
                            this.postsWithoutSection = postsArray;
                        }
                    } else {
                        const section = this.sections.find((s) => s.id === sectionId);
                        if (section) {
                            if (addToExisting) {
                                section.posts = [...(section.posts || []), ...postsArray];
                            } else {
                                this.$set(section, 'posts', postsArray);
                            }
                        }
                    }
                    this.sectionLoading[sectionId] = false;
                    this.sectionHasMore[sectionId] = data.hasMore;

                    if(typeof this.currentPage[sectionId] === 'undefined'){
                        this.currentPage[sectionId] = 1;
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.popNotification('Could not load posts. Please try again or contact support.', 'danger');
                })
                .finally(() => {
                    // Any final actions
                });
        },

        fetchPostsForColumn(columnId, skip = 0, addToExisting = false) {
            let postsPerPage = this.postsPerPage;

            let queryParams = new URLSearchParams({
                tab: this.dataSlug,
                skip: skip.toString(),
                limit: postsPerPage.toString(),
                order_by: this.orderBy,
                order_direction: this.orderDirection
            });

            // Only add column parameter for kanban or knowledgebase tabs
            if (this.tab.type === 'kanban' || this.tab.type === 'knowledgebase') {
                queryParams.append(this.column_names, columnId === null ? 'null' : columnId);
            }

            if (this.tab.saved_query_id) {
                queryParams.append('saved_query_id', this.tab.saved_query_id);
            }

            if (this.selectedCategoryId) {
                queryParams.append('category', this.selectedCategoryId);
            }
            if (this.selectedVersion) {
                queryParams.append('version', this.selectedVersion);
            }
            if (this.selectedRelease) {
                queryParams.append('release', this.selectedRelease);
            }
            if (this.selectedPlatform) {
                queryParams.append('platform', this.selectedPlatform);
            }

            this.$http.get(`/http_api/posts?${queryParams.toString()}`)
                .then(({ data }) => {
                    const postsArray = data.data || [];

                    if (columnId === null && this.column_names === 'section') {
                        if (addToExisting) {
                            this.postsWithoutSection = [...this.postsWithoutSection, ...postsArray];
                        } else {
                            this.postsWithoutSection = postsArray;
                        }
                    } else {
                        const column = this.columns.find((c) => c.id === columnId);
                        if (column) {
                            if (addToExisting) {
                                column.posts = [...(column.posts || []), ...postsArray];
                            } else {
                                this.$set(column, 'posts', postsArray);
                            }
                        }
                    }
                    this.sectionLoading[columnId] = false;
                    this.sectionHasMore[columnId] = data.hasMore;

                    if(typeof this.currentPage[columnId] === 'undefined'){
                        this.$set(this.currentPage, columnId, 1);
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.popNotification('Could not load posts. Please try again or contact support.', 'danger');
                });
        },
        loadMorePosts(columnId) {
            const currentPage = this.currentPage[columnId] || 1;
            const nextPage = currentPage + 1;
            const skip = this.postsPerPage * (currentPage);  // Calculate skip based on current page

            this.fetchPostsForColumn(columnId, skip, true);
            this.$set(this.currentPage, columnId, nextPage);
        },

    }
};